<template>
  <div class="row" v-if="definition">
    <h2 class="col-12">Définition</h2>
    <p class="col-12"><dfn class="text-info text-uppercase">{{word}}</dfn>
    <span v-if="definition[1] !== word" class="racine">[{{definition[1]}}]</span>
    <span class="def">{{definition[2]}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Definition',
  props: {
    word: {
      type: String,
      required: true,
    },
    definition: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 1.1rem;
}
p{
  text-align: justify;
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/games/Definition.vue